const style = _theme => ({});

export default style;
